import React from 'react'

const riskCompoenent = () => {
  return (
    <div></div>
  )
}

export default riskCompoenent